import { useRef, useState } from 'react'
import { UploadCloud } from 'lucide-react'
import { cn } from '@/lib/utils'
interface DropzoneProps {
  accept: string
  /** Name of the currently picked file, if any. */
  fileName?: string
  onFile: (file: File) => void
  hint: string
  className?: string
}

/** Click or drop. Kept in the app: used once, so not worth promoting yet. */
export function Dropzone({ accept, fileName, onFile, hint, className }: DropzoneProps) {
  const inputRef = useRef<HTMLInputElement>(null)
  const [dragging, setDragging] = useState(false)

  const take = (files: FileList | null) => {
    const file = files?.[0]
    if (file) onFile(file)
  }

  return (
    <div
      onDragOver={(event) => {
        event.preventDefault()
        setDragging(true)
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={(event) => {
        event.preventDefault()
        setDragging(false)
        take(event.dataTransfer.files)
      }}
      className={cn('w-full', className)}
    >
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        className={cn(
          'flex h-24 w-full flex-col items-center justify-center gap-1.5 rounded-md border border-dashed px-4 text-center transition-colors outline-none',
          'focus-visible:outline-accent focus-visible:outline-2 focus-visible:outline-offset-1',
          dragging
            ? 'border-accent bg-accent/5 text-fg'
            : 'border-border bg-bg-subtle text-fg-subtle hover:border-border-strong hover:text-fg-muted',
        )}
      >
        <UploadCloud className="size-4" />
        {fileName ? (
          <span className="text-fg text-sm">{fileName}</span>
        ) : (
          <span className="text-sm">{hint}</span>
        )}
      </button>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={(event) => take(event.target.files)}
        className="hidden"
      />
    </div>
  )
}
